import { render, staticRenderFns } from "./CardPastCode.vue?vue&type=template&id=74acb214&scoped=true"
import script from "./CardPastCode.vue?vue&type=script&lang=js"
export * from "./CardPastCode.vue?vue&type=script&lang=js"
import style0 from "./CardPastCode.vue?vue&type=style&index=0&id=74acb214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74acb214",
  null
  
)

export default component.exports